import { useEffect, useRef, useState } from "react";
export var useGeolocation = function () {
    var _a = useState(""), error = _a[0], setError = _a[1];
    var isSubscribed = useRef(true);
    var _b = useState(), coords = _b[0], setCoords = _b[1];
    var handleSuccess = function (positoin) {
        if (isSubscribed.current) {
            setCoords(positoin.coords);
        }
    };
    var handleError = function (error) {
        if (isSubscribed.current) {
            setError(error.message);
        }
    };
    useEffect(function () {
        if (!navigator.geolocation) {
            setError("Geolocation is not supported.");
            return;
        }
        navigator.geolocation.getCurrentPosition(handleSuccess, handleError);
        return function () {
            isSubscribed.current = false;
        };
    }, []);
    return { coords: coords, error: error };
};
